import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import { flatMap, forEach } from 'lodash';
import TableUtils from '../../../../../../../utils/TableUtils';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class TableSueldosPagos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.processData(props.data.datos)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: this.processData(nextProps.data.datos)
        });
    }

    processData = (data) => {
        if(data == null)
            return null;

        let info = {};

        forEach(data, (item) => {
            if (item.periodo === null)
                return;
            let periodo = moment(item.periodo);
            let agno = periodo.year();
            let mes = periodo.month();

            if (!info[agno]) {
                info[agno] = {
                    anio: agno,
                    total: 0,
                    meses: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                };
            }

            info[agno].meses[mes] += item.remuneracion;
            info[agno].total += item.remuneracion;
        });

        let result = flatMap(info, (x) => x);

        return result;
    }

    expandedRow = (row) => {
        return (
            <Table striped bordered condensed fill responsive>
                <thead>
                    <tr>
                        <td>Mes</td>
                        <td>Total pagado</td>
                    </tr>
                </thead>
                <tbody>
                    {row.meses.map((item, ix) => <tr key={ix}>
                        <td>{TableUtils.monthFormat(ix)}</td>
                        <td>{TableUtils.ARSFormat(item)}</td>
                    </tr>)}
                </tbody>
            </Table>
        );
    }

    render() {
        return (
                <BootstrapTable data={this.state.data}
                    expandableRow={() => true}
                    expandComponent={this.expandedRow}
                    options={TableUtils.defaultConfig()}>
                    <TableHeaderColumn dataField="anio" width='30' dataFormat={TableUtils.plusButtonFormat} ></TableHeaderColumn>
                    <TableHeaderColumn dataField="anio" isKey>Año</TableHeaderColumn>
                    <TableHeaderColumn dataField="total" dataFormat={TableUtils.ARSFormat}>Total pagado</TableHeaderColumn>
                </BootstrapTable>
        );
    }
}

TableSueldosPagos.propTypes = {
    data: PropTypes.array,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};
export default TableSueldosPagos;



// WEBPACK FOOTER //
// ./src/scenes/empresas/components/empresas-detalle/components/panel-datos-empresa/components/TableSueldosPagos.js